/* eslint-disable camelcase */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

/** 公会榜 / 国家榜 / 土豪榜共用的 Countdown.HSD 样式 */
export const killAnimalRankDhmsConfig = {
  text: {day: 'D', hour: 'H', minute: 'M', second: 'S'},
  style_config: {
    time: {
      bg: `url(${HostMaps.auto.otherStatic}/static/all/682d791d8767c3a943fcf333)`,
      color: '#FFFFFF',
    },
    desc_color: '#FFFBD8',
    separator: false,
    separator_color: '#FFFBD8',
  },
}

export enum PageTypeEnum {
  公会PK赛 = 1,
  国家荣耀赛,
  土豪榜,
}

export enum UnionRankTypeEnum {
  老公会 = 1,
  新公会,
}

/** 赛程 */
export interface KillAnimalSubTabItem {
  start_num: number
  end_num: number
  date_des: string
  rank_id: number
  countdown: number
  is_select: boolean
}

/** get_base_data 返回的 data 结构 */
export interface KillAnimalBaseData {
  err_msg: string
  activity_id: number
  /** 公会榜当前选中的 tab：1 老公会 2 新公会 */
  select_union_tab_type: UnionRankTypeEnum
  /** key 为子 tab 类型字符串，如 PK 赛各阶段 */
  sub_tab_data: Record<string, KillAnimalSubTabItem[]>
}

export const get_base_data = createAsyncThunk(
  'KillAnimal/get_base_data',
  async (p, store: any) => {
    const resp = await http.post('/activity/api/eid_al_adha/2026/v1/get_base_data', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

const initialState: {
  base_data: KillAnimalBaseData
  /** 活动页主tab：公会PK赛 / 国家荣耀赛 / 土豪榜 */
  page_tab: PageTypeEnum
} = {
  base_data: {
    err_msg: '',
    activity_id: 0,
    select_union_tab_type: UnionRankTypeEnum.老公会,
    sub_tab_data: {},
  },
  page_tab: PageTypeEnum.公会PK赛,
}
export const KillAnimalSlice = createSlice({
  name: 'KillAnimal',
  initialState,
  reducers: {
    /** 设置活动页主tab */
    setPageTab(state, action: PayloadAction<PageTypeEnum>) {
      state.page_tab = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_base_data.fulfilled, (state, action) => {
      const data = (action.payload as any)?.data ?? action.payload
      state.base_data = {
        ...state.base_data,
        ...data,
      }
    })
  },
})
export default KillAnimalSlice.reducer
export const KillAnimalActions = KillAnimalSlice.actions
